module.exports = __webpack_public_path__ + "static/media/pirhana.9341f8db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/pirhana.png
// module id = 329
// module chunks = 0